import { isFn } from './checkers';
import { untrackStart, untrackEnd } from './reaction';
export var untracked = function (untracker) {
    untrackStart();
    var res;
    try {
        if (isFn(untracker)) {
            res = untracker();
        }
    }
    finally {
        untrackEnd();
        return res;
    }
};
untracked.create = function () {
    untrackStart();
    var completed = false;
    return function () {
        if (!completed) {
            untrackEnd();
            completed = true;
        }
    };
};
